module.exports = {
  NOTY_TYPE: {
    NOTY_ERROR: 'error',
    NOTY_SUCCESS: 'success',
    NOTY_WARNING: 'warning',
  },
}
